module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BlackItalic.23d16cfb.eot";